import React from "react";
import { RoleResponseModel } from "../../_core/_model";
import { IoMdDoneAll } from "react-icons/io";
import { FaTag } from "react-icons/fa6";
import { useAppContext } from "../../context/AppContext.tsx";
import TooltipButton from "../Tools/TooltipButton.tsx";
import RoleDetailsOnTitle from "./RoleDetailsOnTitle.tsx";

interface request {
    role: RoleResponseModel,
    exButton: any,
    noDescription?: boolean
}
export function RoleCard({ role, exButton, noDescription }: request) {
    const { dimensions, roles } = useAppContext();
    return (
        <div
            key={role.roleName}
            className="d-flex justify-content-between align-items-start px-2 py-2 mb-2 rounded j_g_rt_roleC"
            style={{
                background: dimensions.find((r) => r.dimensionCode == role.dataMapCode)?.bg,
                color: dimensions.find((r) => r.dimensionCode == role.dataMapCode)?.color,
                borderLeft: '4px solid ' + (dimensions.find((r) => r.dimensionCode == role.dataMapCode)?.color || '#333'),
                transition: 'all 0.2s ease',
                width: "100%"
            }}
        >
            <div className="d-flex flex-column w-100">
                <div className="d-flex flex-row justify-content-between align-items-center w-100">
                    <div className="d-flex flex-row gap-1 align-items-center text-truncate">
                        {
                            role.roleID == -1 ? <IoMdDoneAll /> : <FaTag />
                        }
                        {
                            (role.roleID != null && role.roleID > 0) ?
                                <TooltipButton maxWidth={750} title={() => <RoleDetailsOnTitle roleId={role.roleID != null ? role.roleID.toString() : ""} />
                                }>
                                    <strong>{role.roleName}</strong>
                                </TooltipButton> :
                                <strong>{role.roleName}</strong>
                        }
                    </div>
                </div>
                {
                    (typeof noDescription == 'undefined' || !noDescription) &&
                    <div>
                        <div>{role.description}</div>
                    </div>
                }
                <div>
                    {/* {role.filterConditions?.length > 0 && (
                        <TooltipButton title={expandedRole === role.roleName ? "Collapse" : "View filters"}>
                            <button
                                onClick={e => {
                                    e.stopPropagation();
                                    setExpandedRole(expandedRole === role.roleName ? null : role.roleName);
                                }}
                                className="btn btn-link p-0"
                            >
                                {expandedRole === role.roleName ? <FaChevronUp /> : <FaChevronDown />}
                            </button>
                        </TooltipButton>
                    )} */}
                </div>
                {/* <AnimatePresence>
                    {expandedRole === role.roleName && role.filterConditions?.length > 0 && (
                        <motion.ul
                            initial={{ opacity: 0, height: 0 }}
                            animate={{ opacity: 1, height: 'auto' }}
                            exit={{ opacity: 0, height: 0 }}
                            transition={{ duration: 0.3 }}
                            className="mt-2 text-sm overflow-hidden"
                        >
                            {role.filterConditions?.split(Separators.row).map((c, idx) => (
                                <li key={idx}>{c} {c} {c}</li>
                            ))}
                        </motion.ul>
                    )}
                </AnimatePresence> */}
            </div>
            {
                exButton
            }
        </div>
    )
}

export default RoleCard;